import {
    Datagrid,
    List,
    FunctionField,
    EditButton,
    ShowButton,
    TextInput,
    TopToolbar,
    FilterButton
} from "react-admin";
import React from "react";
import { FieldGuesser } from '@api-platform/admin';

const filters = [
    <TextInput label="Title" source="title" />,
    <TextInput label="Course ID" source="course" />,
];

const ListActions = () => (
    <TopToolbar>
        <FilterButton/>
    </TopToolbar>
);

export const VideoList = () => (
    <List actions={<ListActions/>}  filters={filters}>
        <Datagrid bulkActionButtons={false} rowClick={"edit"}>
            <FieldGuesser source="title" />
            <FieldGuesser source="duration" sortable={false} />
            <FieldGuesser source="brightcoveVideoId" sortable={false}/>
            <FieldGuesser source="courseTitle" label="Course" sortable={false}/>
            <FunctionField
                source="tracks"
                sortable={false}
                render={
                    record =>
                        record.tracks && record.tracks.length > 0 ?
                            <i className="fa-solid fa-check"></i> :
                            <i className="fa-solid fa-xmark"></i>
            }
            />
            <FieldGuesser source="createdAt"/>
            <>
                <FunctionField
                    source="tracks"
                    render={
                        record =>
                            record.tracks && record.tracks.length > 0 ?
                                <EditButton/> :
                                ''}
                />
                <ShowButton/>
            </>
        </Datagrid>
    </List>
);
